// extracted by mini-css-extract-plugin
module.exports = {"menu":"contextMenu_menu__zLAFB","bookmarked":"contextMenu_bookmarked__01q9g"};